import {GetWalletResponse_Tab_Coins_CoinsHeader} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {FadeTransition} from '@aboutyou/transitions';
import {
  COLORS,
  GenericIconName,
  Icon,
  SPACING,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useIsMissionsActive} from '../../utils/useIsMissionsActive';
import {CoinsWalletHeaderProgressBars} from './CoinsWalletHeaderProgressBars';
import {StatusUpdate} from './StatusUpdate';

export const CoinsWalletHeader: React.FC<
  GetWalletResponse_Tab_Coins_CoinsHeader & {className?: string}
> = ({
  className,
  available,
  pending,
  statusUpdate,
  deprecatedProgressBars,
  deprecatedDescription,
  deprecatedIsBonusClaimable,
}) => {
  const isMissionsActive = useIsMissionsActive();
  return (
    <Wrapper className={className} $increasePaddingBottom={isMissionsActive}>
      <StatusUpdate type={statusUpdate?.type} />
      <Available>
        <Icon asset={GenericIconName.CoinsDoubleColor} size="M" />
        <FadeTransition duration={300} uniqueKey={available}>
          <Text
            size="px80"
            color="White"
            weight="heavy"
            data-testid="coinsWalletHeaderAvailableCoins"
          >
            {available}
          </Text>
        </FadeTransition>
      </Available>
      {pending && (
        <Pending data-testid="coinsWalletHeaderPendingCoins">
          <Icon
            asset={GenericIconName.CoinsStriped}
            size="S"
            fill={COLORS.White}
          />
          <Text
            size="px10"
            color="White"
            weight="mediumBold"
            dangerouslySetInnerHTML={{__html: pending.text}}
          />
        </Pending>
      )}
      {!isMissionsActive && (
        <CoinsWalletHeaderProgressBars
          deprecatedProgressBars={deprecatedProgressBars}
          deprecatedDescription={deprecatedDescription}
          deprecatedIsBonusClaimable={deprecatedIsBonusClaimable}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<{$increasePaddingBottom: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  gap: 8px;
  padding-bottom: ${({$increasePaddingBottom}) =>
    $increasePaddingBottom ? SPACING['Y.Xl3'] : '20px'};
`;

const Available = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -40px;
`;

const Pending = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -20px;
`;
